import React, { useState } from 'react';
import { Menu, X, LogOut, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const MobileHeader = ({ title, showBack = false, onBack }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [showMenu, setShowMenu] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  const getUserInitials = () => {
    if (!user) return '??';
    const firstInitial = user.firstName?.[0] || '';
    const lastInitial = user.lastName?.[0] || '';
    return (firstInitial + lastInitial).toUpperCase();
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 bg-white z-40 safe-area-top">
        <div className="flex items-center justify-between px-4 h-14 border-b border-gray-200">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img
              src="/logo-touba-rennes.jpg"
              alt="Touba Rennes"
              className="h-10 w-auto object-contain"
            />
            <div>
              <h1 className="text-base font-bold text-gray-900">{title}</h1>
            </div>
          </div>

          {/* Menu Button */}
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
          >
            {showMenu ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Bande verte séparatrice */}
        <div className="h-1 bg-gradient-to-r from-primary-600 via-primary-500 to-green-400"></div>
      </header>

      {/* Dropdown Menu */}
      {showMenu && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/20 z-30 backdrop-blur-sm"
            onClick={() => setShowMenu(false)}
          />

          {/* Menu */}
          <div className="fixed top-14 right-0 m-4 bg-white rounded-xl shadow-2xl z-40 min-w-[280px] border border-gray-200">
            {/* User Info */}
            <div className="p-4 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold shadow-md">
                  {getUserInitials()}
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-gray-900">
                    {user?.firstName} {user?.lastName}
                  </p>
                  <p className="text-sm text-gray-500">{user?.email}</p>
                </div>
              </div>
            </div>

            {/* Menu Items */}
            <div className="p-2">
              <button
                onClick={() => {
                  setShowMenu(false);
                  navigate('/parametres');
                }}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-left"
              >
                <User size={20} className="text-gray-500" />
                <span className="font-medium text-gray-700">Mon profil</span>
              </button>

              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-red-50 transition-colors text-left text-red-600"
              >
                <LogOut size={20} />
                <span className="font-medium">Déconnexion</span>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MobileHeader;
